"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keccak_1 = require("./keccak");
/**
 * derive Address from public key
 * @param pubKey the public key
 */
function publicKeyToAddress(pubKey) {
    return keccak_1.keccak256(pubKey.slice(1)).slice(12);
}
exports.publicKeyToAddress = publicKeyToAddress;
/**
 * to check if a value presents an address
 * @param v the value to be checked
 */
function isAddress(v) {
    return typeof v === 'string' && /^0x[0-9a-f]{40}$/i.test(v);
}
exports.isAddress = isAddress;
/**
 * encode the address to checksum address that is compatible with eip-55
 * @param address input address
 */
function toChecksumAddress(address) {
    if (!isAddress(address)) {
        throw new Error('invalid address');
    }
    address = address.slice(2).toLowerCase();
    const hash = keccak_1.keccak256(address);
    let checksumAddress = '0x';
    for (let i = 0; i < address.length; i++) {
        // tslint:disable-next-line:no-bitwise
        let byte = hash[i >> 1];
        if (i % 2 === 0) {
            // tslint:disable-next-line:no-bitwise
            byte >>= 4;
        }
        if (byte % 16 >= 8) {
            checksumAddress += address[i].toUpperCase();
        }
        else {
            checksumAddress += address[i];
        }
    }
    return checksumAddress;
}
exports.toChecksumAddress = toChecksumAddress;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkcmVzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jcnkvYWRkcmVzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHFDQUFvQztBQUNwQzs7O0dBR0c7QUFDSCxTQUFnQixrQkFBa0IsQ0FBQyxNQUFjO0lBQzdDLE9BQU8sa0JBQVMsQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFBO0FBQy9DLENBQUM7QUFGRCxnREFFQztBQUVEOzs7R0FHRztBQUNILFNBQWdCLFNBQVMsQ0FBQyxDQUFNO0lBQzVCLE9BQU8sT0FBTyxDQUFDLEtBQUssUUFBUSxJQUFJLG1CQUFtQixDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQTtBQUMvRCxDQUFDO0FBRkQsOEJBRUM7QUFFRDs7O0dBR0c7QUFDSCxTQUFnQixpQkFBaUIsQ0FBQyxPQUFlO0lBQzdDLElBQUksQ0FBQyxTQUFTLENBQUMsT0FBTyxDQUFDLEVBQUU7UUFDckIsTUFBTSxJQUFJLEtBQUssQ0FBQyxpQkFBaUIsQ0FBQyxDQUFBO0tBQ3JDO0lBQ0QsT0FBTyxHQUFHLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsV0FBVyxFQUFFLENBQUE7SUFDeEMsTUFBTSxJQUFJLEdBQUcsa0JBQVMsQ0FBQyxPQUFPLENBQUMsQ0FBQTtJQUUvQixJQUFJLGVBQWUsR0FBRyxJQUFJLENBQUE7SUFDMUIsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLE9BQU8sQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUU7UUFDckMsc0NBQXNDO1FBQ3RDLElBQUksSUFBSSxHQUFHLElBQUksQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUE7UUFDdkIsSUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsRUFBRTtZQUNiLHNDQUFzQztZQUN0QyxJQUFJLEtBQUssQ0FBQyxDQUFBO1NBQ2I7UUFFRCxJQUFJLElBQUksR0FBRyxFQUFFLElBQUksQ0FBQyxFQUFFO1lBQ2hCLGVBQWUsSUFBSSxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUMsV0FBVyxFQUFFLENBQUE7U0FDOUM7YUFBTTtZQUNILGVBQWUsSUFBSSxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUE7U0FDaEM7S0FDSjtJQUNELE9BQU8sZUFBZSxDQUFBO0FBQzFCLENBQUM7QUF2QkQsOENBdUJDIn0=